import { Channel } from "pusher-js";

import { getSessionId } from "../../utils/sessionId";
import { getPusher } from "../pusher/pusherConnection";
import { NudgeStore } from "./NudgeStore";
import { NudgeAction } from "./types";

// Intent/Tiresias channel — subscribes private-session-${sessionId} on the
// SHARED Pusher connection (src/services/pusher) and routes "nudge" events to
// NudgeStore. The connection lifecycle is owned by <PusherBootstrap/>; this
// module only subscribes/unsubscribes its own channel. (Was PusherClient.ts,
// which also built the connection — that moved to the neutral provider.)
let channel: Channel | null = null;

const handleNudge = (data: unknown): void => {
  const nudge = data as NudgeAction;
  if (nudge && typeof nudge.id === "string" && typeof nudge.mechanism === "string") {
    NudgeStore.push(nudge);
  } else {
    console.warn(`[intent] nudge payload missing id/mechanism — skipped`, data);
  }
};

export function subscribeIntentChannel(): void {
  const pusher = getPusher();
  if (!pusher || channel) return;
  const channelName = `private-session-${getSessionId()}`;
  channel = pusher.subscribe(channelName);
  channel.bind("pusher:subscription_succeeded", () => {
    console.log(`[intent] subscribed channel=${channelName}`);
  });
  channel.bind("nudge", handleNudge);
}

export function unsubscribeIntentChannel(): void {
  if (!channel) return;
  channel.unbind_all();
  getPusher()?.unsubscribe(channel.name);
  channel = null;
}
